export class IFilterEvents{
    type: string = "Todos";
    state: string = "Todos";
    category: number = 0;
}